module.exports = __webpack_public_path__ + "static/media/xx.37844cad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xx.png
// module id = 2616
// module chunks = 2